import React from "react";
import { UI_STYLES, HeaderBar } from "@/components/ui";
import { motion } from "framer-motion";
import { useChatScreenViewModel } from "./ChatScreenViewModel";
import { ChatContentWithoutPremium } from "./ui/ChatContentWithoutPremium";
import { ChatHeader } from "./ui/ChatHeader";
import BottomInputChat from "./ui/BottomInputChat";
import ChatMessages from "./ui/ChatMessages";
import ScreenLoader from "@/components/ui/ScreenLoader";
import ModalCenterSheet from "@/components/ui/modals/ModalCenterSheet";
import EmptyQuestionsAlert from "./ui/EmptyQuestionsAlert";
import { Helmet } from "react-helmet-async";

const ChatScreen: React.FC = () => {
  const {
    navigateToSubscription,
    navigateToHome,
    isEnabledInput,
    currentMessage,
    messages,
    sendUserMessage,
    setCurrentMessage,
    hasSubscription,
    availableQuestionsCount,
    fetchMessages,
    chatLoading,
    skipUp,
    skipDown,
    isLoading,
    isCenterSheetOpen,
    closeCenterSheet,
    astrologistName,
    astrologistAvatar,
    astrologistDescription,
  } = useChatScreenViewModel();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3, ease: "easeInOut" }}
      className={`h-full ${UI_STYLES.bgDarkBlue}`}
    >
      <Helmet>
        <title>Чат с астрологом | Мир Звёзд</title>
        <meta name="description" content="Задайте вопросы профессиональному астрологу в приватном чате. Получите персональные астрологические советы, толкование карт Таро и ответы на важные жизненные вопросы. До 4 вопросов в месяц для премиум пользователей." />
        <meta name="keywords" content="чат с астрологом, астрологическая консультация, персональный астролог, астрологические советы, толкование карт, астрология онлайн, консультация астролога" />
        <meta name="author" content="bpTech" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Чат с астрологом | Мир Звёзд" />
        <meta property="og:description" content="Задайте вопросы профессиональному астрологу в приватном чате. Получите персональные астрологические советы и толкование карт Таро." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://мир-звезд.рф/chat" />
      </Helmet>
      <ModalCenterSheet open={isCenterSheetOpen} onClose={closeCenterSheet}>
        <EmptyQuestionsAlert
          onCancel={closeCenterSheet}
        />
      </ModalCenterSheet>
      <ScreenLoader isLoading={isLoading} />
      <div
        className={`flex flex-col overflow-x-hidden h-full bg-no-repeat bg-center bg-cover `}
      >
        <HeaderBar
          title="Чат с астрологом"
          onBack={() => navigateToHome()}
          backgroundColor={UI_STYLES.bgDarkBlue4}
        />
        <ChatHeader astrologistName={astrologistName} astrologistAvatar={astrologistAvatar} astrologistDescription={astrologistDescription} count={availableQuestionsCount} />
        {!hasSubscription ? (
          <ChatContentWithoutPremium
            navigateToSubscription={navigateToSubscription}
          />
        ) : (
        <ChatMessages messages={messages} skipUp={skipUp} skipDown={skipDown} fetchItems={fetchMessages} loading={chatLoading} />
        )}

        <BottomInputChat
          isEnabled={isEnabledInput}
          text={currentMessage}
          onChangeText={setCurrentMessage}
          onSend={sendUserMessage}
        />
      </div>
    </motion.div>
  );
};

export default ChatScreen;
